const projectsData = [
  {
    id: 1,
    title: 'Counsel Station',
    description: 'AI-Powered Legal Operating System',
    longDescription: 'A comprehensive digital infrastructure for legal proceedings. Features Deepgram AI for real-time transcription and LiveKit (WebRTC) for low-latency virtual hearings. Successfully migrated from managed services to self-hosted OCI, achieving a 100% reduction in operational costs.',
    technologies: ['Next.js', 'Deepgram AI', 'LiveKit', 'Oracle Cloud', 'WebRTC'],
    image: '/images/img/counsel station.jpeg',
    demoLink: 'https://counselstation.netlify.app/',
    codeLink: 'https://github.com/ikehvictor',
    category: 'web'
  },
  {
    id: 2,
    title: 'EFACSM Hub',
    description: 'Real-Time Audio & Connectivity Platform',
    longDescription: 'Engineered a high-performance audio room platform with sub-second latency using WebRTC. Implemented resilient signaling with exponential backoff and resolved multi-device conflicts. Optimized for mobile with an APK size of 15-17 MB through aggressive R8 shrinking.',
    technologies: ['Flutter', 'WebRTC', 'Go', 'Oracle Cloud', 'R8'],
    image: '/images/img/efacsm.jpeg',
    demoLink: 'https://efacsm.netlify.app/',
    codeLink: 'https://github.com/ikehvictor',
    category: ['web', 'mobile'],
    hasDualMockup: true,
    webImage: '/images/img/efacsm.jpeg',
    appImage: '/images/img/efacsm app.jpeg'
  },
  {
    id: 3,
    title: 'NDO Furnitures',
    description: 'Premium E-commerce Mobile Application',
    longDescription: 'Architected a production-ready furniture catalog app using a feature-first modular structure. Integrated Riverpod for robust state management and Palette Generator for a dynamic, imagery-adaptive UI/UX.',
    technologies: ['Flutter', 'Riverpod', 'GoRouter', 'Palette Generator'],
    image: '/images/img/ndo web.jpeg',
    demoLink: 'https://ndofurnitures.vercel.app/',
    codeLink: 'https://github.com/ikehvictor',
    category: ['web', 'mobile'],
    hasDualMockup: true,
    webImage: '/images/img/ndo web.jpeg',
    appImage: '/images/img/ndo furniture app.jpeg'
  },
  {
    id: 4,
    title: 'PottersHand',
    description: 'Automated Marketing & Programmatic Video Tool',
    longDescription: 'Developed an innovative system to generate professional marketing videos programmatically using Remotion. Built a modular Next.js landing page optimized for extreme performance and SEO.',
    technologies: ['Next.js', 'TailwindCSS', 'Motion Graphics'],
    image: '/images/img/pottershand web.jpeg',
    demoLink: 'https://pottershandservices.com',
    codeLink: 'https://github.com/ikehvictor',
    category: ['web', 'mobile'],
    hasDualMockup: true,
    webImage: '/images/img/pottershand web.jpeg',
    appImage: '/images/img/pottershand app.jpeg'
  },
  {
    id: 5,
    title: 'EIPS Backend & OCI Migration',
    description: 'Enterprise-Grade Backend Façade',
    longDescription: 'Designed a high-concurrency Go REST API using the Fiber framework and multi-layered clean architecture. Executed a zero-downtime "Big Bang" migration for 3,000+ users from Supabase Cloud to Oracle Cloud Infrastructure.',
    technologies: ['Go', 'Fiber', 'JWT', 'Oracle Cloud', 'Clean Architecture'],
    image: '/images/img/eips.png',
    demoLink: 'https://github.com/ikehvictor',
    codeLink: 'https://github.com/ikehvictor',
    category: 'web'
  },
  {
    id: 6,
    title: 'Crown Hospital',
    description: 'Professional hospital website with booking and ai feature',
    longDescription: 'Crown Hospital is a premium, biophilic-inspired healthcare platform that combines advanced medical expertise with state-of-the-art technology. It features an AI-powered Symptom Navigator to guide patients to the right specialists and a streamlined Digital Booking Concierge for seamless appointment scheduling, all designed to provide holistic and compassionate care.',
    technologies: ['ReactJS', 'Tailwind', 'GitHub'],
    image: '/images/img/crownhospital.jpeg',
    demoLink: 'https://crownhospital.netlify.app/',
    codeLink: 'https://github.com/ikehvictor',
    category: 'web'
  },
  {
    id: 7,
    title: 'Ably',
    description: 'Ably connects skilled disabled professionals across Africa with inclusive employers.',
    longDescription: 'Ably connects skilled disabled professionals across Africa with inclusive employers. Remote-friendly roles, verified talent, and thoughtful accommodations.',
    technologies: ['NextJs', 'Tailwind', 'GitHub'],
    image: '/images/img/ably.png',
    demoLink: 'https://ably-fawn.vercel.app/',
    codeLink: 'https://github.com/ikehvictor',
    category: 'web'
  },
  {
    id: 8,
    title: 'GerioCare',
    description: 'Professional elderly care services with compassion and dedication',
    longDescription: 'We\'re a passionate team committed to improving the lives of the elderly through quality home care services. Whether your loved one needs daily support or occasional check-ins, we match families with trained nurses who provide compassionate and professional care.',
    technologies: ['ReactJS', 'Tailwind', 'GitHub'],
    image: '/images/img/go.png',
    demoLink: 'https://geriocare.netlify.app/',
    codeLink: 'https://github.com/ikehvictor',
    category: 'web'
  },
  {
    id: 9,
    title: 'Physio Digital',
    description: 'Tech-driven healthcare initiative revolutionizing physiotherapy',
    longDescription: 'To lead the transformation of physiotherapy through innovative technology, education, and collaboration, ensuring quality care reaches every corner of the world. Functions as both a web application and a mobile service.',
    technologies: ['ReactJS', 'Tailwind', 'Flutter', 'Firebase', 'GitHub'],
    image: '/images/img/physiowebsite.png',
    demoLink: 'https://github.com/ikehvictor',
    codeLink: 'https://github.com/ikehvictor',
    category: ['web', 'mobile'],
    hasDualMockup: true,
    webImage: '/images/img/physiowebsite.png',
    appImage: '/images/img/app.png'
  },
];

export default projectsData;